module.exports = __webpack_public_path__ + "static/media/ks_background.dd869bb3.jpg";